import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '@/lib/auth/useAuth';

export const Route = createFileRoute('/suspended')({
  component: SuspendedRoute,
});

function SuspendedRoute() {
  const { profile, signOut } = useAuth();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-parchment px-6 text-center">
      <p className="font-sans text-xs uppercase tracking-[0.18em] text-oxblood">
        Account suspended
      </p>
      <h1 className="mt-3 font-serif text-3xl text-ink sm:text-4xl">
        Your access has been paused.
      </h1>
      <p className="mt-4 max-w-md font-sans text-sm text-ink/70">
        An administrator has suspended this account.
        {profile?.suspended_reason ? (
          <>
            {' '}
            The reason given: <span className="text-ink">{profile.suspended_reason}</span>
          </>
        ) : null}
      </p>
      <p className="mt-4 max-w-md font-sans text-sm text-ink/60">
        If you believe this is a mistake, write to{' '}
        <a href="mailto:editorial@archetelos.stream" className="text-oxblood underline">
          editorial@archetelos.stream
        </a>{' '}
        and an editor will review it. Anything you have already published remains published.
      </p>
      <button
        type="button"
        onClick={() => void signOut()}
        className="mt-8 rounded-md border border-ink/20 px-5 py-2 font-sans text-sm font-medium text-ink hover:border-oxblood hover:text-oxblood"
      >
        Sign out
      </button>
    </div>
  );
}
